import React from 'react';
import NoteColumnMenu from 'main/components/show/grid/columnHeaderCell/noteColumnMenu.jsx';

/**
 * Item note column header cell
 *
 */
export default React.createClass({
  displayName: 'GridNoteColumnHeaderCell',

  propTypes: {
    title: React.PropTypes.string.isRequired,
    id: React.PropTypes.string.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    return (
      <div className="grid-utility-column-title">
        <div>
          {this.props.title}
          <NoteColumnMenu
            id={this.props.id}
            currentWidth={this.props.currentWidth}
            user={this.props.user}
          />
        </div>
      </div>
    );
  },
});
